"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SmallToggleButton = _interopRequireDefault(require("../components/SmallToggleButton"));

var createTextToolbarButton = function createTextToolbarButton(_ref) {
  var icon = _ref.icon,
      tooltip = _ref.tooltip,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement;

  var TextToolbarButton = function TextToolbarButton(_ref2) {
    var _ref2$active = _ref2.active,
        active = _ref2$active === void 0 ? false : _ref2$active,
        onClick = _ref2.onClick;
    return _react.default.createElement(_SmallToggleButton.default, {
      active: active,
      icon: icon,
      tooltip: tooltip,
      tooltipPlacement: tooltipPlacement,
      onClick: onClick
    });
  };

  TextToolbarButton.propTypes = {
    active: _react.PropTypes.bool,
    onClick: _react.PropTypes.func.isRequired
  };
  return TextToolbarButton;
};

var _default = createTextToolbarButton;
exports.default = _default;
module.exports = exports.default;